import cookie from 'cookie';

import browserUtil from './browser';

const getOmsMemberNumber = () => {
  const { _mem } = cookie.parse(browserUtil.getDocument()?.cookie ?? '');
  const parsedMem = _mem ? JSON.parse(_mem) : '';
  return parsedMem?.health?.id as string | undefined;
};

export default getOmsMemberNumber;
